import React, { Component } from "react"

import { connect } from "react-redux"
import { translate } from "react-translate"
import { Link } from "react-router-dom"

import {
  Segment,
  Grid,
  Menu,
  Image,
  Header,
  Icon,
  Modal,
  Button,
  Item
} from "semantic-ui-react"

import MenuEdition from "../../DevisFactures/EditionDevisFactures/MenuEdition"
import BandeauNoir from "../../Entete/BandeauNoir"
import BouttonEntete from "../../Entete/BouttonEntete"
import { circleDown } from "react-icons-kit/icomoon/circleDown"
import { arrowLeft2 } from "react-icons-kit/icomoon/arrowLeft2"
import ParametreDocument from "./ParametreDocument"

const mapStateToProps = state => ({
  app: state.app
})

class ConnectedParamDevisDoc extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dateDevisFacturesData: [{ dateEnteteBody: "Janvier 2017 :" }]
    }
  }

  componentWillMount() {}

  render() {
    return (
      <Segment id="main">
        <ParametreDocument />
      </Segment>
    )
  }
}

const ParametreDevisDocument = connect(mapStateToProps)(ConnectedParamDevisDoc)
export default translate("ParametreDevisDocument")(ParametreDevisDocument)



// WEBPACK FOOTER //
// ./src/components/Pro/Parametres/DocumentDevisFacture/ParametreDocumentDevisFactureComponent.jsx